import { Box, CircularProgress, styled } from '@mui/material';

interface LoaderProps {
  minHeight?: number;
  style?: React.CSSProperties;
}

export function Loader({ minHeight = 310, style }: Readonly<LoaderProps>) {
  return (
    <LoaderContainer style={{ minHeight: minHeight, ...style }}>
      <CircularProgress />
    </LoaderContainer>
  );
}

export function LoaderAbsolute({ style }: Readonly<LoaderProps>) {
  return (
    <LoaderAbsoluteContainer style={{ ...style }}>
      <CircularProgress />
    </LoaderAbsoluteContainer>
  );
}

const LoaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
  minHeight: 310,
}));

const LoaderAbsoluteContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
  position: 'absolute',
}));
